import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import { WebSocketDemo } from "../component/WebSocketDemo";

export default function Dashboard2() {
  return (
    <>
      <div id="layout-wrapper">
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Dashboard</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title mb-3">Basic Information</h4>
                  <div className="row">
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">First Name</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Last Name</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Primary E-mail Address</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Primary E-mail Address"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Secondary E-mail Address</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Secondary E-mail Address"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Country</label>
                      <select className="form-select" name="select">
                        <option value="Andorra">Andorra</option>
                        <option value="Andorra">Andorra</option>
                      </select>
                    </div>
                    <div className="col-xxl-3 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Country Code</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder={+376}
                      />
                    </div>
                    <div className="col-xxl-3 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        className="form-control"
                        type="tel"
                        id="example-date-input"
                        placeholder="Phone Number"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Date Of Birth</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Date Of Birth"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Gender</label>
                      <select className="form-select" name="select">
                        <option value="Please Select">Please Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Skype Id</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Skype Id"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Nationality</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Nationality"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title mb-3">Address Details</h4>
                  <div className="row">
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">
                        Address 1 <span className="text-danger">*</span>
                      </label>
                      <textarea
                        id="formmessage"
                        name="msg"
                        rows={3}
                        placeholder="Address 1"
                        className="form-control"
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">
                        Address 2 <span className="text-danger">*</span>
                      </label>
                      <textarea
                        id="formmessage"
                        name="msg"
                        rows={3}
                        placeholder="Address 2"
                        className="form-control"
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">State</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="State"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">City</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="City"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Zip / Postal Code</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Zip / Postal Code"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Po Box</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Po Box"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title mb-3">User Preferences</h4>
                  <div className="row">
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Default Language</label>
                      <select className="form-select" name="select">
                        <option value="Us English">Us English</option>
                        <option value="Hindi">Hindi</option>
                      </select>
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Timezone</label>
                      <input
                        className="form-control"
                        type="text"
                        id="example-date-input"
                        placeholder="Coordinated Universal Time, Greenwich Mean Time"
                      />
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label className="form-label">Time Formate</label>
                      <select className="form-select" name="select">
                        <option value={24}>24</option>
                        <option value={12}>12</option>
                      </select>
                    </div>
                    <div className="col-xxl-6 col-md-6 col-sm-6 mb-3">
                      <label htmlFor="">Date Formate</label>
                      <input
                        className="form-control"
                        type="date"
                        onKeyDown={(e) => e.preventDefault()}
                        id="example-date-input"
                        placeholder="Date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3 text-end">
                <button type="Submit" className="btn btn-primary px-4">
                  Update
                </button>
              </div>
            </div>
            {/* container-fluid */}
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}
